import React from "react";

const QuestionWrapper: React.FC<{ flex?: boolean }> = ({ children, flex, ...props }) => (
  <div
    style={{
      // marginBottom: "1em",
      display: flex ? "flex" : undefined,
      flexDirection: flex ? "column" : undefined,
    }}
    {...props}
  >
    {children}
  </div>
);

export default QuestionWrapper;
